export class AuthenticationToken {
  static IAuthenticationRepository = Symbol("IAuthenticationRepository");
  static LoginViewModel = Symbol("LoginViewModel");
  static AuthenticationUseCase = Symbol("AuthenticationUseCase");
}
